import { memo, useMemo } from 'react'
import { Chip } from 'src/components/shared/Chip'
import { ContractorType } from 'src/constants/contractor/enums'
import { colors } from 'src/theme'
import tw from 'twin.macro'
import { contractorTypeTitles } from 'src/constants/contractor/constants'

interface Props {
  type: ContractorType
}

const contractorTypeMap = {
  [ContractorType.Sub]: {
    color: colors.GRAY_WHITE,
    text: contractorTypeTitles[ContractorType.Sub],
    bgStyle: tw`bg-[#FF6320]`,
  },
  [ContractorType.IC]: {
    color: colors.GRAY_WHITE,
    text: contractorTypeTitles[ContractorType.IC],
    bgStyle: tw`bg-[#2A2133]`,
  },
  [ContractorType.Master]: {
    color: colors.GRAY_WHITE,
    text: contractorTypeTitles[ContractorType.Master],
    bgStyle: tw`bg-[#0056FF]`,
  },
}

const getContractorTypeParams = (type: ContractorType) =>
  contractorTypeMap[type] || {
    color: colors.SHADES_GREY_500,
    text: type,
    bgStyle: tw`bg-[rgba(218, 217, 224, 1)]`,
  }

const ContractorTypeChipComponent = ({ type }: Props) => {
  const params = useMemo(() => getContractorTypeParams(type), [type])

  return (
    <div css={tw`flex items-center`}>
      <div css={tw`py-1 rounded-[10px]`}>
        <Chip className={params.bgStyle} textColor={params.color} text={params.text} />
      </div>
    </div>
  )
}

export const ContractorTypeChip = memo(ContractorTypeChipComponent)
